export interface CampaignPriceParams {
  regularPrice: number
  comparePrice: number
  maxPromotionAmount: number
  campaignPercent: number
  isCampaignActive: boolean
}

export interface CampaignPriceResult {
  finalPrice: number
  originalPrice: number
  discountPercent: number
  shouldShowDiscount: boolean
}

/**
 * Utility function tính campaign price không phụ thuộc vào hooks.
 * Sử dụng cùng logic với useCampaignPrice hook.
 * Được dùng để snapshot giá tại thời điểm add to cart, tránh bị ảnh hưởng bởi invalidate queries.
 */
export function calculateCampaignPrice({
  regularPrice,
  comparePrice,
  maxPromotionAmount,
  campaignPercent,
  isCampaignActive,
}: CampaignPriceParams): CampaignPriceResult {
  // Giá gốc để so sánh là comparePrice nếu có, nếu không thì lấy regularPrice
  const original =
    typeof comparePrice === 'number' && comparePrice > 0
      ? comparePrice
      : regularPrice

  let final = original
  let discount = 0

  // Nếu max_promotion_amount = 0 thì không giảm, giữ nguyên giá gốc
  // Nếu max_promotion_amount > 0 thì chỉ giảm cho item có giá gốc <= max_promotion_amount
  if (
    isCampaignActive &&
    campaignPercent > 0 &&
    maxPromotionAmount > 0 &&
    original <= maxPromotionAmount
  ) {
    // Áp dụng giảm giá theo phần trăm campaign
    final = Math.round(original * (1 - Number(campaignPercent) / 100))
  } else {
    // Không đủ điều kiện giảm giá, giữ nguyên giá gốc
    final = original
  }

  // Làm tròn finalPrice tới hàng nghìn gần nhất
  final = Math.round(final / 1000) * 1000

  // Tính phần trăm giảm giá dựa trên originalPrice và finalPrice
  discount =
    original > 0 ? Math.round(((original - final) / original) * 100) : 0

  // Chỉ sửa phần hiển thị: discountPercent không vượt quá campaignPercent
  // Không tính lại finalPrice, chỉ giới hạn discountPercent cho UI
  const displayDiscount =
    discount > campaignPercent ? campaignPercent : discount

  return {
    finalPrice: final,
    originalPrice: original,
    discountPercent: displayDiscount,
    shouldShowDiscount: displayDiscount > 0,
  }
}
